import gql from 'graphql-tag'

export const ordersByWeek = gql`
  query ordersByWeek($week: Int!, $year: Int!) {
    ordersByWeek(week: $week, year: $year) {
      data {
        id
        date
        submitted
        submitted_at
        editable
        grouped_by_categories {
          name
          data {
            id
            name
            item_number
            slug
            pivot {
              quantity
            }
          }
        }
      }
      excludedDays
    }
  }
`
